import { Tab, Tabs } from '@tovia/man-ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from '../../../redux';
import { CamTrackingPosition } from 'src/client/constants/camTracking';
import { useGenerateCamUrlWithParams } from 'src/client/helpers/urls/useGenerateCamUrlWithParams';

type Props = {
  camTrackingPosition?: CamTrackingPosition;
  hasAllLiveGirls?: boolean;
};

export const CamsTitle = (props: Props) => {
  const intl = useIntl();
  const { loading, error, cams } = useSelector((state) => state.cams);

  const generateCamUrlWithParams = useGenerateCamUrlWithParams({
    trackingPosition: props.camTrackingPosition,
    provider: cams?.[0]?.provider ?? 'streamate',
  });

  if (loading || error || !cams || !cams.length || !cams[0].total) return null;

  return (
    <Tabs className="cams-title">
      <Tab
        name={intl.formatMessage({ id: 'cams.tabs.liveGirls', defaultMessage: 'Live Girls' })}
        value="live-girls"
        active
      />
      {props.hasAllLiveGirls ? (
        <Tab
          as="a"
          href={generateCamUrlWithParams('/cams-list')}
          target="_blank"
          value="all-live-girls"
          name={intl.formatMessage({ id: 'cams.tabs.seeAllLiveGirls', defaultMessage: 'See All Live Girls' })}
        />
      ) : (
        <></>
      )}
    </Tabs>
  );
};
